// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2ZhrO","actionsCol":"EnrolledClinics_actionsCol__3dIp-"};